import React from "react";
import "./ContactInfo.css";
import { FaPhone, FaEnvelope , FaMapMarkerAlt } from "react-icons/fa";
const ContactInfo = () => {
  return (
    <div className="contact-info-container">
      <div className="contact-card">
        <div className="icon">
          <FaMapMarkerAlt />
        </div>
        <p>Islamabad, PAKISTAN</p>
      </div>
      <div className="contact-card">
        <div className="icon">
          <FaPhone />
        </div>
        <p>+92-312-917-6057</p>
      </div>
      <div className="contact-card">
        <div className="icon">
          <FaEnvelope />
        </div>
        <p>alnisaquraninstitute@gmail.com</p>
      </div>
    </div>
  );
};

export default ContactInfo;
